// =============================================================================
// FILE: packages/renderer/src/components/purchase/ManualPaymentNotice.tsx
// PURPOSE: Prominent notice shown on every purchase surface while manual payment
//   is enabled — E-transfer instructions + "PayPal being prepared". No live
//   PayPal button is displayed anywhere this notice appears.
// =============================================================================

import { type JSX } from 'react';
import { Landmark, Copy, Check } from 'lucide-react';
import { useState } from 'react';
import { ETRANSFER_EMAIL, MANUAL_PAYMENT_NOTICE } from '../../config/manualPayment.js';

export function ManualPaymentNotice({ compact = false }: { compact?: boolean }): JSX.Element {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(ETRANSFER_EMAIL); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch { /* */ }
  };
  return (
    <div data-testid="manual-payment-notice" className="rounded-xl px-4 py-3"
      style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.35)' }}>
      <div className="flex items-start gap-3">
        <Landmark className="h-4 w-4 mt-0.5 shrink-0 text-amber-400" />
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-[0.18em] text-amber-400/90 font-semibold">Manual payment enabled</div>
          {!compact && (
            <p className="text-[12px] text-zinc-300 leading-relaxed mt-1 mb-2">{MANUAL_PAYMENT_NOTICE}</p>
          )}
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-[11px] text-zinc-400">E-transfer:</span>
            <span data-testid="etransfer-email" className="text-[12px] font-mono font-bold text-amber-200">{ETRANSFER_EMAIL}</span>
            <button data-testid="copy-etransfer" onClick={copy}
              className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-md text-amber-300 hover:text-amber-200 transition"
              style={{ border: '1px solid rgba(245,158,11,0.35)' }}>
              {copied ? <><Check className="h-3 w-3" /> Copied</> : <><Copy className="h-3 w-3" /> Copy</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
